var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('nav',[_c('router-link',{staticClass:"button",attrs:{"to":"/"}},[_vm._v("Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }